var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "72d55949093375336807fa0d3b924b28c559e0e4"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dfh-accounts-site@designs-for-health"] = {
  id: "72d55949093375336807fa0d3b924b28c559e0e4"
};